import React from "react";
import developerImg from "../../assets/developer-img.png";
import "./styles.scss";
import { Button } from "antd";

const DeveloperPage = () => {
  return (
    <section className="developer-page-section">
      <div className="section-title-text">Are you a developer?</div>
      <div className="section-title-desc">And looking for a publisher?</div>
      <section className="developer-content-section">
        <section className="left-section">
          <img src={developerImg} alt="#" className="developer-img" />
        </section>
        <section className="right-section">
          <div className="small-heading">Dear Developer,</div>
          <div className="content-text">
            Currently we're not looking for third party games to publish, but if
            you really enchanted us with your demo, we may consider making an
            exception :)
          </div>
          <div className="colored-text">
            Please send us only a few screenshots and gameplay URL
            (Youtube/Vimeo) to: dev@digitalmelody.eu
          </div>
          <div className="content-text">
            Please keep in mind, that we are not be able to reply to each
            submission. We will do our best to get back to you in 10 days, but
            only if your game could be published by Digital Melody Games.
          </div>
          <br />
          <br />
          <a href="mailto:usmn.nwz@gmail.com">
            <Button className="more-games-btn">Contact Us</Button>
          </a>
        </section>
      </section>
    </section>
  );
};

export default DeveloperPage;
